import React, {Fragment} from "react"
import { Link } from "react-router-dom"

const BlockStyleTen = () => {
    return (
        <Fragment>
            <div className="block-style-ten">
                <div className="section-title mb-45 pe-xxl-5" data-aos="fade-up">
                    <h6 className="sub-title-two mb-20">Sistema de Reconocimiento Facial</h6>
                    <h3 className="sect-title mb-25">Protege Tu Sistema Con Reconocimiento Facial</h3>
                    <p className="mb-15">Estrategizamos continuamente ideas que cumplen con los estándares
                        en lugar de alineaciones basadas en rendimiento. Aprovechamos globalmente soluciones
                        alternativas existentes a través de usuarios virtuales.</p>
                    <p>Estrategizamos continuamente ideas que cumplen con los estándares en lugar de
                        alineaciones basadas en rendimiento. Aprovechamos globalmente las existentes.</p>
                    <Link className="theme_btn mt-55" to="/project-details">Más Detalles</Link>
                </div>
            </div>
        </Fragment>
    )
}

export default BlockStyleTen